import gql from 'graphql-tag';

export const circle = gql`
  query circle($id: RecordID!) {
    me {
      id
      circles(circle_id: $id) {
        records {
          id
          name
          asset_image {
            id
            url
          }
          contacts {
            total
            records {
              id
              contact {
                id
                first_name
                last_name
                emails(slice: { limit: 1 }) {
                  records {
                    id
                    email_address
                  }
                }
                phones(slice: { limit: 1 }) {
                  records {
                    id
                    phone_number
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
